import { utcToZonedTime as r } from "date-fns-tz";
import { ConfigService as i } from "@nextgen-web-framework/core";
const g = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], a = (t) => {
  const { NEXT_PUBLIC_TIMEZONE: n } = i.getConfigs();
  return new Date(r(t, n));
}, m = (t, n = !0, o = !1) => {
  const e = n ? a(t) : new Date(t);
  return `${`${String(e.getDate())} ${g[e.getMonth()]}${o ? "" : ","} ${String(
    e.getFullYear()
  )}`}, ${new Date(e.getTime()).toLocaleTimeString(navigator.language, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: !1
  })}`;
};
export {
  m as C
};
//# sourceMappingURL=commonHelper-dc0f7990.mjs.map
